import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";

const UnauthorizedApp = ({ logoutRedirect }) => {
  const handleLogout = () => {
    // Trigger logoutRedirect on click
    logoutRedirect();
  };

  return (
    <Box
      id="error-page"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        maxWidth: "450px",
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      <Typography
        variant="subtitle"
        mt={4}
        mb={4}
        sx={{ fontSize: "16px", fontWeight: "400" }}
      >
        <div>
          <h2>Access Denied</h2>
          <p>You do not have permission to view this application.</p>
        </div>
      </Typography>
      <Link
        to="dashboard"
        style={{
          textDecoration: "none",
          background: "#F40000",
          padding: "10px 20px",
          color: "white",
          borderRadius: "15px",
        }}
        onClick={handleLogout} // Trigger the logout function
      >
        Logout
      </Link>
    </Box>
  );
};

export default UnauthorizedApp;
